import { IpAuthenticator, AdobePassAuthenticator } from 'watch-authenticators';
import { AdobePass } from 'enums';

const { Env: AdobePassEnv } = AdobePass;

let ipAuthenticator;
let adobePassAuthenticator;

export const adobe = (opts) => {
    if (adobePassAuthenticator) {
        return adobePassAuthenticator;
    }

    if (!opts) {
        throw new Error("Must specify opts the first time Adobe Authenticator is retrieved");
    }

    adobePassAuthenticator = new AdobePassAuthenticator(opts);
    return adobePassAuthenticator;
};

export const ip = (opts = { partner: 'watchespn', platform: 'web' }) => {
    if (ipAuthenticator) {
        return ipAuthenticator;
    }

    if (!opts) {
        throw new Error("Must specify opts the first time IP Authenticator is retrieved");
    }

    ipAuthenticator = new IpAuthenticator(opts);
    return ipAuthenticator;
};

export default {
    adobe,
    ip
};



// WEBPACK FOOTER //
// ./app/lib/auth/Authenticator.js